import type { IMetadata } from '@adloid-technologies/discover-sdk';

/**
 * Equinox Configurator (linkId 2362).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2362.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape. Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    Equinox: {
      id: 'Equinox',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      backgroundIdentifer: 'dome',
      variants: {
        'equinox-ev-rs-fwd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4784',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'common_interior',
              sku: '4780',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4777',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '4256',
              projectId: '49',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'common_interior',
          exteriorColorIdentifier: 'exterior-color'
        },
        'equinox-ev-rs-fwd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4784',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'common_interior',
              sku: '4780',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4777',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '4256',
              projectId: '49',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'common_interior',
          exteriorColorIdentifier: 'exterior-color'
        }
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: '4256',
          project: '49'
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: '4850',
          project: '59'
        }
      },
      ambientLighting: {
        ambientColors: '#ff1300,#ff9f51,#aafef4,#00b6ff,#61ff87',
        ambientLightings: {
          ambient0: {
            isDefault: true,
            identifier: 'common_interior',
            materialName: [
              'INT_AMBIENT_LIGHT'
            ],
            parentNodeName: [],
            emissiveColor: [
              255,
              19,
              0
            ],
            emissiveIntensity: 0.5
          },
          ambient1: {
            isDefault: false,
            identifier: 'common_interior',
            materialName: [
              'INT_AMBIENT_LIGHT'
            ],
            parentNodeName: [],
            emissiveColor: [
              255,
              159,
              81
            ],
            emissiveIntensity: 0.5
          },
          ambient2: {
            isDefault: false,
            identifier: 'common_interior',
            materialName: [
              'INT_AMBIENT_LIGHT'
            ],
            parentNodeName: [],
            emissiveColor: [
              170,
              254,
              244
            ],
            emissiveIntensity: 0.5
          },
          ambient3: {
            isDefault: false,
            identifier: 'common_interior',
            materialName: [
              'INT_AMBIENT_LIGHT'
            ],
            parentNodeName: [],
            emissiveColor: [
              0,
              182,
              255
            ],
            emissiveIntensity: 0.5
          },
          ambient4: {
            isDefault: false,
            identifier: 'common_interior',
            materialName: [
              'INT_AMBIENT_LIGHT'
            ],
            parentNodeName: [],
            emissiveColor: [
              97,
              255,
              135
            ],
            emissiveIntensity: 0.5
          }
        },
        relevantVariants: [
          'equinox-ev-rs-fwd-2026',
          'equinox-ev-rs-fwd-2025'
        ]
      },
      colors: {
        interior: {
          '48za413x8262': {
            sku: '4780',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026',
              'equinox-ev-rs-fwd-2025'
            ],
            notCompatibleExteriorColors: []
          }
        },
        exterior: {
          '2fa06p9t7v8f': {
            sku: '4771',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026',
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '69xux2hlscm1': {
            sku: '4775',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026',
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '5xzh26yrdinw': {
            sku: '4777',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026',
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '2fbmj48vpgsi': {
            sku: '4773',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026'
            ]
          },
          '2fbmj48vpgsi-my25': {
            sku: '4773',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '10xy9i682nxc': {
            sku: '4774',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026',
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '37xytt0490j8': {
            sku: '4776',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026'
            ]
          },
          '37xytt0490j8-my25': {
            sku: '4776',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '536y2x49kxgq': {
            sku: '4772',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026',
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '4zd4onnmg2y5': {
            sku: '4778',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026',
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '2phvl5sq89cx': {
            sku: '4781',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026'
            ]
          },
          '2phvl5sq89cx-my25': {
            sku: '4781',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '2phvil5sq89c2': {
            sku: '6045',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026'
            ]
          },
          '2phvil5sq89c2-my25': {
            sku: '6045',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2025'
            ]
          },
          '2phvil57sq89cx': {
            sku: '6044',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2026'
            ]
          },
          '2phvil57sq89cx-my25': {
            sku: '6044',
            project: '59',
            relevantVariants: [
              'equinox-ev-rs-fwd-2025'
            ]
          }
        }
      },
      features: {
        '29kx4ja7eg7r': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3ud49gqncb2e': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'headlamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1jhh1m7485kl': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'Sport rail finish',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Sport rail finish',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '8vlg0walqaux': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '8s8tx9p847si': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xjhzg2xjvike: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        g8rwatb2qokf: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '80a8vikbz9mc': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'Charging port',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Charging port',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '5axgfh2btytx': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'Red/black interior',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        bf5spqe7qghc: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'ambient lighting',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2kzy6a0jhsu2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'HeadsUp display',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2hc2o7cuwka9': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'infotainment',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_infotainment',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2je8obbpqtv4': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'Driver Infomation center',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Driver Infomation center',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '4cq85subl38y': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'Long range',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '5glz7rcq53uo': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [
            {
              message: 'Onstar connected',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Onstar connected',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        UeZiCrgosRRz: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          messages: [],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        }
      },
      accessories: {
        '3ckvx6gvve78': {
          view: 'exterior',
          groupId: 'equinox-ev-rs-fwd-g0',
          display: true,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_ROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Roof',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3ckvx6gvve79': {
          view: 'exterior',
          groupId: 'equinox-ev-rs-fwd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_SUNROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Roof',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3ckvx6gvve67': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Front Badge Illuminated',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Front Badge Illuminated',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Front Badge',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '60cyi4386dh7': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'E_1_Door_OSRVM_Cap_S4X_FL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_E_1_Door_OSRVM_Cap_S4X_FL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_OSRVM_Cap',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            f9s7b4hdeiz7: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '26awwpydj3k4': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Roof_CrossRails_VQQ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Roof_CrossRails_VQQ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '41j05csmotu4': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Side_Mud_Guards',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Side_Mud_Guards',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Side_Mud_Guards',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4g3h4ls28grj': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Side_Perimeter_Lamps_S3I',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Side_Perimeter_Lamps_S3I',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            f9s7b4hdeiz7: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '56cy0d0cnz7u': {
          view: 'interior',
          groupId: 'equinox-ev-rs-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor_Mat_VAV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Floor_Mat_VAV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Floor_Mat_VAV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2esb5gdmfpk8': {
          view: 'interior',
          groupId: 'equinox-ev-rs-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor_Liner_RIA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Floor_Liner_RIA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Floor_Liner_RIA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '496aqzregvz5': {
          view: 'exterior',
          groupId: 'equinox-ev-rs-fwd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Trunk_Cargo_BoxMat_SD3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Trunk_Cargo_BoxMat_SD3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '1nad76ictp6j': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4e8rsvm8yulq': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Trunk_Cargo_Net_W2D',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Trunk_Cargo_Net_W2D',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '1nad76ictp6j': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6bmwunaxygjc': {
          view: 'exterior',
          groupId: 'equinox-ev-rs-fwd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Trunk_Cargo_Organiser_RWU',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Trunk_Cargo_Organiser_RWU',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '1nad76ictp6j': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3l2bs2aiit7y': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Trunk_Cargo_Shade_VRS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_Trunk_Cargo_Shade_VRS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Trunk_Cargo_Shade',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '1nad76ictp6j': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '50t7txtk3kvs': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'I_7_Trunk_Cargo_Tray_CAV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_I_7_Trunk_Cargo_Tray_CAV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Trunk_Cargo_Tray_CAV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '1nad76ictp6j': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3ktjpvxvvvkj': {
          view: 'exterior',
          groupId: 'equinox-ev-rs-fwd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'I_7_Trunk_Cargo_Tray_SHX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Accessory_I_7_Trunk_Cargo_Tray_SHX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Trunk_Cargo_Tray_SHX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '1nad76ictp6j': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        }
      },
      packages: {},
      interactions: {
        f9s7b4hdeiz7: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_interior',
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_interior',
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ]
        },
        '1nad76ictp6j': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 1.577,
                beta: 1.388,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 1.56,
                beta: 1.583,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ]
        },
        '2mbv5mgd2j0t': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'common_interior',
                'common_exterior',
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'common_interior',
                'common_exterior',
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ],
          availableFor: {
            accessories: [
              '3ckvx6gvve79'
            ]
          }
        },
        '3cqy8q29b96c': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ]
        },
        '2ca59s6yd3u9': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ]
        },
        '1dzdmvhl8vp3': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'equinox-ev-rs-fwd-2026',
            'equinox-ev-rs-fwd-2025'
          ]
        }
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            upperRadiusLimit: 6.7,
            lowerRadiusLimit: 3.2,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            target: {
              x: 0,
              y: 0.65,
              z: 0
            },
            isFovZoomModeOn: false
          }
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {}
        }
      },
      usdzPathWithVariable: ''
    }
  }
};
